"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.phpFilesToScannedProjects = exports.nodeFilesToScannedProjects = void 0;
const node_1 = require("./node");
Object.defineProperty(exports, "nodeFilesToScannedProjects", { enumerable: true, get: function () { return node_1.nodeFilesToScannedProjects; } });
const php_1 = require("./php");
Object.defineProperty(exports, "phpFilesToScannedProjects", { enumerable: true, get: function () { return php_1.phpFilesToScannedProjects; } });
//# sourceMappingURL=index.js.map